import { createClient } from "@supabase/supabase-js";
const supabaseUrl = "https://dfjosmdeaqxvjgqpntlf.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRmam9zbWRlYXF4dmpncXBudGxmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTY1MzA1OTMsImV4cCI6MjAzMjEwNjU5M30.Rf3AeL4E4m9lWXVPngh8UJS8mx_EIqj66tFgtOF2dh8";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
